module.exports = __webpack_public_path__ + "media/application/images/map-pin-9bfb7200d21bbc265108580b50af19d7.svg";